var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlue1 = function SvgBlue1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 80,
    viewBox: "0 0 104 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h100a2 2 0 0 1 2 2v76a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.997,
    y: 5.128,
    width: 35.346,
    height: 5.641,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 12.82,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#4673EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 17.948,
    width: 14.675,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.281,
    y: 17.948,
    width: 17.227,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 23.59,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#4673EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 28.718,
    width: 14.675,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68.269,
    y: 28.718,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.773,
    y: 28.718,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 33.846,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#4673EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 65.128,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#4673EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 38.975,
    width: 14.675,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 70.257,
    width: 14.675,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 72.736,
    y: 38.975,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 72.736,
    y: 70.257,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 52.318,
    y: 38.975,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 52.318,
    y: 70.257,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 86.773,
    y: 38.975,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 44.615,
    width: 88.687,
    height: 3.59,
    rx: 0.632,
    fill: "#4673EC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 86.773,
    y: 70.257,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 7.656,
    y: 49.743,
    width: 14.675,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 25.521,
    y: 49.743,
    width: 5.104,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 34.454,
    y: 49.743,
    width: 5.104,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 43.387,
    y: 49.743,
    width: 5.104,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 72.736,
    y: 49.743,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 72.736,
    y: 54.871,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 29.988,
    y: 38.975,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 72.736,
    y: 60,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52.318,
    y: 49.743,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 52.318,
    y: 54.871,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 52.318,
    y: 60,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 86.773,
    y: 49.743,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 29.988,
    y: 70.257,
    width: 15.951,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 86.773,
    y: 54.871,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 86.773,
    y: 60,
    width: 9.571,
    height: 3.59,
    rx: 0.632,
    fill: "#9DB6F7"
  })));
};

export default SvgBlue1;